<template lang="html">
    <div class="page" id="messages">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2 grey">
            <header>
                <h2>All messages</h2>
                <ul class="links">
                    <li style="transform: translateY(-2px)">
                        <button
                            class="openSettings"
                            @click.prevent="deleteOn = !deleteOn"
                            type="button"
                            name="button"
                        >
                            <img class="bin" v-if="!deleteOn" src="@/assets/bin.svg" /><img
                                v-else
                                class="bin"
                                src="@/assets/bin-red.svg"
                            />
                        </button>
                    </li>
                    <li>
                        <router-link class="cancel" :to="{ name: 'playerMessages' }" href="#">
                            <x-icon class="icon" />
                        </router-link>
                    </li>
                </ul>
            </header>

            <div v-if="!messages">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <div v-else-if="messages && messages.length > 0">
                <player-message-item
                    v-for="message in messages"
                    :key="message.id"
                    :deleteOn="deleteOn"
                    :message="message"
                    @messageDeleted="deleteMessage"
                />
            </div>

            <span class="info" v-else>You have no messages</span>
        </div>
    </div>
</template>

<script>
import PlayerMessageItem from "@/views/Player/Messages/components/player-message-item";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "all-messages",
    created() {
        this.getMessages();
    },
    components: { PlayerMessageItem, PreLoaderItem, FadeImage, XIcon },
    data() {
        return {
            messages: false,
            deleteOn: false,
        };
    },
    methods: {
        deleteMessage(message) {
            window.axios.delete("/message/" + message.id).then(() => {
                var index = this.messages.findIndex(($message) => {
                    return $message.id == message.id;
                });
                this.messages.splice(index, 1);

                this.$notify("message deleted");
            });
        },
        goToLocation($url) {
            if (this.$route.query.from) {
                this.$router.go(-1);
            } else {
                this.$router.push($url);
            }
        },
        getMessages() {
            window.axios.get("/message").then((response) => {
                this.messages = response.data;
            });
        },
    },
};
</script>

<style lang="scss">
.message {
    background: white;
    padding: 15px;
    border-radius: 12px;
    margin-bottom: 10px;
    display: block;
    text-decoration: none;

    &.read {
        border-left: 5px solid #60c45c;
    }

    header {
        color: $green_0;
        margin-bottom: 10px;
        .title {
            font-weight: bold;
        }
        .date {
            float: right;
            color: #939a93;
        }
    }
    .copy {
        color: $green_0;
        font-weight: 200 !important;
    }
    .offer {
        margin-top: 10px;
        display: block;
        color: $green_1;
    }
}
</style>
